module.exports = "/_next/static/images/ae-6d497f1cbc288f9cd189720c1797c7a1.svg";